import { ScaleTime, scaleTime } from "d3-scale";
import { format, startOfDay } from "date-fns";
import { ScaleType } from "recharts/types/util/types";

import { GroupedChartDataPoint } from "../types/chart-data";
import { Timeframe } from "../types/timeframe";

const tickerFormatter = ({
  date,
  timeframe,
}: {
  date: Date;
  timeframe: Timeframe;
}) => {
  if (timeframe === "w") {
    return format(date, "MMM dd");
  }
  if (timeframe === "m") {
    return format(date, "MMM dd");
  }
  return format(date, "MMM yy");
};

export function getXAxisArgsForTimeBasedGraph(
  data: GroupedChartDataPoint[],
  timeframe: Timeframe,
): {
  domain?: number[];
  scale?: ScaleTime<number, number> | ScaleType;
  type: "number" | "category" | undefined;
  ticks?: number[];
  tickFormatter?: (val: Date) => string;
} {
  if (!data.length) {
    return {
      domain: [],
      scale: scaleTime(),
      type: "number",
      ticks: [],
      tickFormatter: () => "",
    };
  }

  const tickCount = timeframe === "w" ? 7 : timeframe === "m" ? 4 : 5;

  const numericValues: number[] = data.map((item) => item.day);
  const maxValue = Math.max(...numericValues);
  const minValue = Math.min(...numericValues);

  const timeScale = scaleTime().domain([minValue, maxValue]);

  const ticks = timeScale.ticks(tickCount);

  return {
    domain: timeScale.domain().map((date) => startOfDay(date).getTime()),
    scale: timeScale,
    type: "number",
    ticks: ticks.map((date) => startOfDay(date).getTime()),
    tickFormatter: (date) => tickerFormatter({ date, timeframe }),
  };
}
